import type { ISnippet } from "@/components/RenderedDie/ISnippet";
import {
  Matrix4,
  Quaternion,
  Vector3,
  type Object3D,
  type WebGLProgramParametersWithUniforms,
} from "three";

export class MistMaterialDefinition implements ISnippet {
  rootMesh: Object3D;
  mistShader: WebGLProgramParametersWithUniforms;
  preview?: boolean;

  constructor(
    rootMesh: Object3D,
    mistShader: WebGLProgramParametersWithUniforms,
    preview?: boolean,
  ) {
    this.rootMesh = rootMesh;
    this.mistShader = mistShader;
    this.preview = preview;
  }

  Update() {
    const upQ = new Quaternion().setFromUnitVectors(
      new Vector3(0, 0, -1), // represents threejs forward default direction
      new Vector3(0, this.preview ? 0 : 1, this.preview ? -1 : 0).normalize(),
    );

    const parentQ = new Quaternion();
    this.rootMesh.parent?.updateWorldMatrix(true, false);
    this.rootMesh.parent?.getWorldQuaternion(parentQ);

    parentQ.invert().multiply(upQ);

    this.mistShader.uniforms.u_Matrix.value =
      new Matrix4().makeRotationFromQuaternion(parentQ);
  }
}
